import React from 'react'
import PropTypes from 'prop-types'
import styles from './BoldSlatePlugin.scss'

const BoldNode = ({ attributes, children }) => (
  <span {...attributes} style={{fontWeight: 'bold'}} className={styles.BoldNode}>
    {children}
  </span>
)

BoldNode.propTypes = {
  attributes: PropTypes.object,
  children: PropTypes.node
}

export default BoldNode



// WEBPACK FOOTER //
// ./src/components/BoldSlatePlugin/BoldNode.js